import React, { useEffect, Fragment, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { Grid, Toolbar, AppBar, Modal, Dialog, DialogTitle, DialogActions, DialogContent, Button, IconButton, Typography } from '@material-ui/core';
import { Table } from './components';
import { useDispatch, useSelector } from 'react-redux';
import { analyticActions } from '_actions';
import Filter from './components/Filter';
import ZnDateRange from 'common/znFields/ZnDateRange';
import { addDays } from 'date-fns';
import moment from 'moment';



const defaultStartDate = new Date('2020-01-01');
const defaultEndDate = new Date();

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    marginRight: ({ opened }) => opened ? "400px" : 0,

  },
  spacer: {
    flexGrow: 1
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
}));

const Analytics = () => {

  const [opened, setOpened] = useState(sessionStorage.getItem('analyticsFiltersOpened') === 'true');
  const handleOpenchange = (opened) => {
    setOpened(opened);
  }
    const classes = useStyles({ opened: opened });



  const data = useSelector(state => state.analytics)
  const dispatch = useDispatch();

  const [filters, setFilters] = useState();

  const handleFiltersChange = (filters) => {
    setFilters(filters);
  }

  useEffect(() => {
    const ff = { ...filters };
    if (typeof ff.startDate !== "undefined") {
      // ff.from = ff.startDate === "" ? '1900-01-01' : ff.startDate;
      ff.from = ff.startDate;
    }
    if (typeof ff.endDate !== "undefined") {

      // ff.to = ff.endDate === "" ? '2500-01-01' : ff.endDate;
      ff.to = ff.endDate;
    }
    delete ff.startDate
    delete ff.endDate

    dispatch(analyticActions.getAll(ff.from, ff.to));
    dispatch(analyticActions.getUser(ff.from, ff.to));
    dispatch(analyticActions.getDepartment(ff.from, ff.to));
  }, [filters, dispatch]);



  return (
    <Fragment>
      <AppBar color="default" position="sticky">
        <Toolbar>
          <span className={classes.spacer} />
          <Filter
            filtersChange={handleFiltersChange}
            onOpenChange={handleOpenchange}

          />
        </Toolbar>
      </AppBar>
      <div className={classes.root}>
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Table name="All" data={data.all} />
          </Grid>
          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Table name="Department" data={data.department} />
          </Grid>

          <Grid
            item
            lg={12}
            md={12}
            xl={12}
            xs={12}
          >
            <Table name="User" data={data.user} />
          </Grid>

        </Grid>
      </div>
    </Fragment>
  );
};

export { Analytics };
